export default {
    screenWMS: {
        detail: 'Order Detail',
        log: 'Scan Log',
        printPickQty: 'Scanned',
        printPickTotal: 'Total QTY',
        customer: 'Customer',
        type: 'Type',
        Condition: 'Condition Value',
        Created: 'Created By',
        Enter: 'Enter address keywords(separated by ;)',
        printPick: 'Print Pick List',
        waveId: 'Wave ID',
        Status: 'Status',
        completion: 'Completion Time',
        orderCount: 'Order Count',
        orderID: 'Order ID',
        sortingStation: 'Sorting Station',
        Creator: 'Creator',
        creation: 'Creation Time',
        wmsID: 'WMS ID',
        pick: 'Pick Qty',
        sort: 'Sort Qty',
        total: 'Total Item Qty',
        basket: 'Basket ID',
        SKU: 'SKU',
        order: 'Order',
        scan: 'Scan Time',
        sortingTime: 'Sorting Time',
        history: 'History',
        Print: 'Print',
        PrintAll: 'Print All',
        Skip: 'Skip',
        unSkip: 'unSkip',
        close: 'Close',
        shelves: 'Number of shelves',
        address: 'Large screen address',
        Printer: 'Printer Information',
        allHis: 'Complete Historical Records',
        basketS: 'Basket ID(Start)',
        basketE: 'Basket ID(End)',
        orderHis: 'Order Historical Records',
        lampConfig: 'LED Rack Config',
        lamp: 'LED Rack ID',
        Equipment: 'Device ID',
        ps1: 'Basket ID start value must be less than end value',
        ps2: 'Address format error',
        ps3: 'File loaded. Printing… Please wait.',
        ps4: 'No Printable Data, Printing Failed.',
        ps5: 'Wave ID Cannot Be Empty',
    }
};
